import { getSubdomain, isSaaSSubdomain } from 'utils/getSubdomain';
import SaaSNavbar from './SaaSNavbar';
import Navbar from './Navbar';
import React from 'react';

const HorizontalNavbar = () => {
  return isSaaSSubdomain() ? <SaaSNavbar /> : <Navbar />;
};

export default HorizontalNavbar;
